import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useReviews } from '../hooks/useReviews';
import AuthModal from './AuthModal';
import styles from './ReviewModal.module.css';

function ReviewModal({ hairstylistId, hairstylistName, existingReview, onClose }) {
  const { currentUser } = useAuth();
  const { addOrUpdateReview } = useReviews(hairstylistId);
  const [rating, setRating] = useState(existingReview?.rating || 0);
  const [hoverRating, setHoverRating] = useState(0);
  const [comment, setComment] = useState(existingReview?.comment || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    if (existingReview) {
      setRating(existingReview.rating);
      setComment(existingReview.comment || '');
    }
  }, [existingReview]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) {
      setShowAuthModal(true);
      return;
    }

    if (rating === 0) {
      setError('Veuillez sélectionner une note');
      return;
    }

    setError('');
    setLoading(true);

    try {
      await addOrUpdateReview(rating, comment);
      onClose();
    } catch (err) {
      setError(err.message || 'Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  if (showAuthModal) {
    return <AuthModal onClose={() => setShowAuthModal(false)} />;
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.closeBtn} onClick={onClose}>
          ✕
        </button>
        <h2>{existingReview ? 'Modifier mon avis' : 'Noter'} {hairstylistName}</h2>
        {error && <div className={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className={styles.ratingSection}>
            <label>Note</label>
            <div className={styles.starsInput}>
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  className={`${styles.starBtn} ${
                    star <= (hoverRating || rating) ? styles.active : ''
                  }`}
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoverRating(star)}
                  onMouseLeave={() => setHoverRating(0)}
                >
                  ★
                </button>
              ))}
            </div>
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="comment">Commentaire (optionnel)</label>
            <textarea
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={4}
              placeholder="Partagez votre expérience..."
            />
          </div>
          <button type="submit" className={styles.submitBtn} disabled={loading}>
            {loading ? 'Envoi...' : existingReview ? 'Modifier mon avis' : 'Publier la note'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ReviewModal;

